module.exports = __webpack_public_path__ + "media/images/front/programs/icon-arrow-down-67824131dd85a25e0dc3ad6f6a122e98.svg";